import api from "./axios";

const API_URL = "/student-feedback";

export const getAsyncStudentFeedback = (userId = null, sessionId = null) => {
  const params = {};
  if (userId && Number(userId) > 0) params.user_id = userId;
  if (sessionId && Number(sessionId) > 0) params.session_id = sessionId;
  const query = Object.keys(params).length ? { params } : undefined;
  return api.get(`${API_URL}/async`, query);
};
